import LanguageForm from '@vo/js/components/LanguageForm'
import LanguageDrawer from '@vo/js/components/LanguageDrawer'

export default (function () {
    LanguageForm.create()
    LanguageDrawer.create()
})
